import Action from 'redux/helpers/createAction'
const name = 'user'

export const getCurrentUser = Action(name + '/GET_CURRENT_USER')

export const getCurrentUserSuccess = Action(name + '/GET_CURRENT_USER_SUCCESS', (user, id) => ({
  user,
  id
}))

export const getCurrentUserFailure = Action(name + '/GET_CURRENT_USER_FAILURE', error => ({
  error
}))

export const register = Action(name + '/REGISTERING', (email, password, firstName, lastName) => ({
  email,
  password,
  firstName,
  lastName
}))

export const registerSuccess = Action(name + '/REGISTERING_SUCCESS', (token, data) => ({
  token,
  data
}))

export const registerFailure = Action(name + '/REGISTERING_FAILURE', errors => ({
  errors
}))

export const login = Action(name + '/LOGGING_IN', (email, password) => ({
  email,
  password
}))

export const loginSuccess = Action(name + '/LOGGING_IN_SUCCESS', (token, data) => ({
  token,
  data
}))

export const loginFailure = Action(name + '/LOGGING_IN_FAILURE', errors => ({
  errors
}))

export const autoLogin = Action(name + '/AUTO_LOG_IN', token => ({
  token
}))

export const autoLoginSuccess = Action(name + '/AUTO_LOG_IN_SUCCESS', token => ({
  token
}))

export const autoLoginFailure = Action(name + '/AUTO_LOG_IN_FAILURE', errors => ({
  errors
}))

export const logout = Action(name + '/LOGOUT')

export const logoutSuccess = Action(name + '/LOGOUT_SUCCESS')

export const logoutFailure = Action(name + '/LOGOUT_FAILURE', errors => ({
  errors
}))

export const updateProfile = Action(name + '/PROFILE_UPDATE', (id, payload) => ({
  id,
  payload
}))

export const updateProfileSuccess = Action(name + '/PROFILE_UPDATE_SUCCESS', data => ({
  data
}))

export const updateProfileFailure = Action(name + '/PROFILE_UPDATE_FAILURE', errors => ({
  errors
}))

export const updatePassword = Action(name + '/PASSWORD_UPDATE', (id, payload) => ({
  id,
  payload
}))

export const updatePasswordSuccess = Action(name + '/PASSWORD_UPDATE_SUCCESS')

export const updatePasswordFailure = Action(name + '/PASSWORD_UPDATE_FAILURE', errors => ({
  errors
}))

export const getPersonalData = Action(name + '/GET_PERSONAL_DATA')

export const getEmailNotifications = Action(name + '/GET_EMAIL_NOTIFICATIONS')

export const getEmailNotificationsSuccess = Action(
  name + '/GET_EMAIL_NOTIFICATIONS_SUCCESS',
  emailNotifications => ({
    emailNotifications
  })
)

export const getEmailNotificationsFailure = Action(
  name + '/GET_EMAIL_NOTIFICATIONS_FAILURE',
  error => ({
    error
  })
)

export const setEmailNotifications = Action(name + '/SET_EMAIL_NOTIFICATIONS', (id, payload) => ({
  id,
  payload
}))
export const setEmailNotificationsSuccess = Action(name + '/SET_EMAIL_NOTIFICATIONS_SUCCESS')

export const setEmailNotificationsFailure = Action(
  name + '/SET_EMAIL_NOTIFICATIONS_FAILURE',
  errors => ({
    errors
  })
)
